"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePropsFromAttributes = void 0;
const mapHtmlAttributesToReactElementAttributes_1 = require("./mapHtmlAttributesToReactElementAttributes");
const convertInlineStyleToMap_1 = require("./convertInlineStyleToMap");
function generatePropsFromAttributes(attributes, key) {
    const props = Object.assign({ key }, (0, mapHtmlAttributesToReactElementAttributes_1.mapHtmlAttributesToReactElementAttributes)(attributes));
    if (props.style) {
        if (typeof props.style === 'string') {
            props.style = (0, convertInlineStyleToMap_1.convertInlineStyleToMap)(props.style);
        }
    }
    else {
        delete props.style;
    }
    return props;
}
exports.generatePropsFromAttributes = generatePropsFromAttributes;
